const makeDescription = (text: string, max_length = 120) => {
  if (text.length > max_length)
    return [text.slice(0, max_length), "..."].join("")
  return text
}

export default makeDescription
